import * as React from 'react'
import { SVGProps } from 'react'

const SvgRingingBlueStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.426 0s-.624 5.823 3.245 9.205C19.54 12.587 25 12.426 25 12.426s-6.214-.266-9.265 3.41C12.685 19.51 12.42 25 12.42 25s-.62-6.233-3.418-8.897C5.938 13.183 0 12.5 0 12.5s6.234-.079 9.285-3.167C12.335 6.246 12.425 0 12.425 0Z"
      fill="#2689C9"
    />
  </svg>
)

export default SvgRingingBlueStar
